import { render } from "./MyReservations.vue?vue&type=template&id=c72f495a"
import script from "./MyReservations.vue?vue&type=script&lang=js"
export * from "./MyReservations.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyReservations.vue?vue&type=style&index=0&id=c72f495a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__